import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/hackzurich2022-swissre-challenge/hackzurich2022-swissre-challenge/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Extended Reality technologies help to simulate dangerous real-world
situations. They add new perspectives on risk and can convey the consequences
of natural catastrophes in first person. We challenge you to utilise them for
a disaster simulation.`}</p>
    </PageDescription>
    <img {...{
      "src": "https://docs.microsoft.com/en-us/windows/mixed-reality/discover/images/hls19_governmentutilitieshologram_001-940px.jpg?ocid=AID3054426",
      "alt": null
    }}></img>
    <h2>{`Challenge details`}</h2>
    <hr></hr>
    <p>{`Please visit our `}<span>{`Deep Dive Workshop`}</span>{` on Friday evenings`}</p>
    <ul>
      <li parentName="ul">{`When: Friday 16th September 2022, 21:30 - 22:05 & 22:15 - 22:50
(CEST)`}</li>
      <li parentName="ul">{`Where: Room Cobol (2nd Floor)`}</li>
      <li parentName="ul">{`Stream: `}<a parentName="li" {...{
          "href": "https://us06web.zoom.us/j/88176700152?pwd=YURVeWtySXpHNEp3WnNrUHFaci90QT09"
        }}>{`Zoom Link`}</a></li>
    </ul>
    <hr></hr>
    <p>{`Extended Reality (VR/AR/MR) technologies are powerful in simulating costly or dangerous real-world situations. They can help us to create new perspectives on risk or to convey the consequences of natural catastrophes in first person. We challenge you to create a natural catastrophe (e.g., flood) simulation utilising Extended Reality technologies.`}</p>
    <p>{`Climate change poses one of the most pervasive risks to our planet. Swiss Re makes the world more resilient, helping communities and businesses to recover quickly after a disaster. We strive to mitigate the impact of natural catastrophes such as flood and thus save lives. In the Risk Engineering Services team, we work in new and innovative ways to identify and prevent the toughest risks across the globe, and we see great potential in applying emerging technologies to achieve this. For this challenge, we focus on solutions that leverage Extended Reality technology to raise awareness and increase resilience for natural catastrophes such as extreme weather events and floods. The solution can contain but is not limited to`}</p>
    <ul>
      <li parentName="ul">{`VR/AR: Simulation of flood scenarios from an indoor point of view`}</li>
      <li parentName="ul">{`AR: Simulation of a flood scenario in a real-world use case (e.g., existing facility)`}</li>
      <li parentName="ul">{`AR: Smartphone-based app that has access to elevation data that visualizes impact of a flood events and provides assistance such as escape routes (similar to Google Maps AR)`}</li>
      <li parentName="ul">{`VR: Awareness raising through catastrophe scenarios (e.g., a natural or man-made catastrophe in a subway station, live concert, example, example)`}</li>
    </ul>
    <p>{`If you want to address additional challenges in your solution, think about adding metrics and damage estimation based on different flood levels, Gamification Elements and ways to scale/promote this application (e.g. as open source) for different stakeholders such as companies, municipalities, NGOs or citizens (private users).`}</p>
    <p>{`FLOAT Video `}<a parentName="p" {...{
        "href": "https://youtu.be/c9mpJEM1Er4"
      }}>{`https://youtu.be/c9mpJEM1Er4`}</a></p>
    <h2>{`3D Assets`}</h2>
    <p><a parentName="p" {...{
        "href": "https://drive.google.com/drive/folders/1YoWkNRFjnNcfIHk71voG9-kO44reWToZ?usp=sharing"
      }}>{`https://drive.google.com/drive/folders/1YoWkNRFjnNcfIHk71voG9-kO44reWToZ?usp=sharing`}</a>{`
PW: SwissReSwiss`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      